/**
 * Decision rules of MapContainer that the Farm View "Field details" tab
 * changed, kept pure so they can be tested without Leaflet / React.
 *
 * - `hidden`: the tab keeps the map mounted while the Farm map tab is showing.
 *   The map then sits in a display:none box (0x0, Leaflet's fit-bounds math
 *   yields NaN), so redraws are skipped while hidden and one full update runs
 *   when it becomes visible again.
 * - Field selection: the tab passes `onFieldSelect` so its own selection state
 *   stays in sync; the Field View (no `onFieldSelect`) just updates Redux.
 */

const MAP_UPDATE = {
  SKIP: 'skip', // hidden: don't touch Leaflet
  FULL: 'full', // just became visible: one full updateMap
  NORMAL: 'normal', // visible before and after: the usual change checks
};

const mapUpdateOnPropsChange = ({ hidden, wasHidden }) => {
  if (hidden) return MAP_UPDATE.SKIP;
  if (wasHidden) return MAP_UPDATE.FULL;
  return MAP_UPDATE.NORMAL;
};

const shouldDrawOnMount = ({ selectedField, hidden }) =>
  Boolean(selectedField && !hidden);

const routeFieldSelection = ({ onFieldSelect, setSelectedEntities }, field) => {
  if (onFieldSelect) {
    onFieldSelect(field);
    return;
  }
  setSelectedEntities(null, null, field, null);
};

module.exports = {
  MAP_UPDATE,
  mapUpdateOnPropsChange,
  shouldDrawOnMount,
  routeFieldSelection,
};
